<template>
    <div class="questions-container">
        <div class="d-flex px-0 tablinks-container" style="overflow: unset">
            <button id="tablink-t-f" class="tablinks"
                    :class="{errInputs:  template.questions['trueOrFalse'].isError || template.questions['trueOrFalse']['errors']['weight']['isError'], active:  currentTab === 'trueOrFalse'}"
                    @click="openTap($event , 'trueOrFalse', template.questions['trueOrFalse'].title)">
                    <div class="d-flex justify-content-center align-items-center card-content-container">
                        <p class="product-details">{{template.questions['trueOrFalse'].title}}</p>
                        <span class="product-details-full">{{template.questions['trueOrFalse'].title}}</span>
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="penDesign" @click.prevent="showModalEdit('trueOrFalse')"/>
                    </div>
            </button>
            <button id="tablink-m-c" class="tablinks"
                    :class="{errInputs:  template.questions['multipleChoices'].isError || template.questions['multipleChoices']['errors']['weight']['isError'], active:  currentTab === 'multipleChoices'}"
                    @click="openTap($event , 'multipleChoices', template.questions['multipleChoices'].title)">
                    <div class="d-flex justify-content-center align-items-center card-content-container">
                        <p class="product-details">{{template.questions['multipleChoices'].title}}</p>
                        <span class="product-details-full">{{template.questions['multipleChoices'].title}}</span> &nbsp;&nbsp;
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="penDesign" @click.prevent="showModalEdit('multipleChoices')"/>
                    </div>

            </button>
            <button id="tablink-f-t" class="tablinks"
                    :class="{errInputs:  template.questions['freeText'].isError || template.questions['freeText']['errors']['weight']['isError'] , active:  currentTab === 'freeText'}"
                    @click="openTap($event , 'freeText', template.questions['freeText'].title)">
                    <div class="d-flex justify-content-center align-items-center card-content-container">
                        <p class="product-details">{{template.questions['freeText'].title}}</p>
                        <span class="product-details-full">{{template.questions['freeText'].title}}</span> &nbsp;&nbsp;
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="penDesign" @click.prevent="showModalEdit('freeText')"/>
                    </div>
            </button>
            <button id="tablink-s" class="tablinks"
                    :class="{errInputs:   template.questions['slides'].isError || template.questions['slides']['errors']['weight']['isError'], active:  currentTab === 'slides'}"
                    @click="openTap($event , 'slides', template.questions['slides'].title)">
                    <div class="d-flex justify-content-center align-items-center card-content-container">
                        <p class="product-details">{{template.questions['slides'].title}}</p>
                        <span class="product-details-full">{{template.questions['slides'].title}}</span> &nbsp;&nbsp;
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="penDesign" @click.prevent="showModalEdit('slides')"/>
                    </div>
            </button>

            <button id="tablink-r" class="tablinks"
                    :class="{errInputs:   template.questions['rank'].isError || template.questions['rank']['errors']['weight']['isError'], active:  currentTab === 'rank'}"
                    @click="openTap($event , 'rank', template.questions['rank'].title)">
                    <div class="d-flex justify-content-center align-items-center card-content-container">
                        <p class="product-details">{{template.questions['rank'].title}}</p>
                        <span class="product-details-full">{{template.questions['rank'].title}}</span> &nbsp;&nbsp;
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="penDesign" @click.prevent="showModalEdit('rank')"/>
                    </div>
            </button>

            <button id="tablink-a" class="tablinks"
                    :class="{errInputs:   template.questions['arrange'].isError || template.questions['arrange']['errors']['weight']['isError'], active:  currentTab === 'arrange'}"
                    @click="openTap($event , 'arrange',template.questions['arrange'].title)">
                    <div class="d-flex justify-content-center align-items-center card-content-container">
                        <p class="product-details">{{template.questions['arrange'].title}}</p>
                        <span class="product-details-full">{{template.questions['arrange'].title}}</span> &nbsp;&nbsp;
                        <font-awesome-icon :icon="['fas', 'pen']" size="sm" class="penDesign" @click.prevent="showModalEdit('arrange')"/>
                    </div>
            </button>
        </div>

        <div id="trueOrFalse" ref="trueOrFalse" class="tabcontent tabcontent-border-style">
            <trueOrFalseQuestion :template="template"/>
        </div>

        <div id="multipleChoices" class="tabcontent tabcontent-border-style">
            <multipleChoicesQuestion :template="template"/>
        </div>

        <div id="freeText" class="tabcontent tabcontent-border-style">
            <freeTextQuestion :template="template"/>
        </div>

        <div id="slides" class="tabcontent tabcontent-border-style">
            <slidesQuestion :template="template" :opType="opType"/>
        </div>

        <div id="rank" class="tabcontent tabcontent-border-style">
            <rankQuestion :template="template" :opType="opType"/>
        </div>

        <div id="arrange" class="tabcontent tabcontent-border-style">
            <arrangeQuestion :template="template" :opType="opType"/>
        </div>
    </div>

    <ModalEditQuestions v-if="isShow" :template="template" :message="message" :qKey="qKey" @saveTitle="showTitle" @close-modal="isShow = false"/>
</template>

<script>
    import {toRef, ref, onMounted} from "vue";
    import trueOrFalseQuestion from "./trueOrFalseQuestion"
    import multipleChoicesQuestion from "./multipleChoicesQuestion"
    import freeTextQuestion from "./freeTextQuestion"
    import slidesQuestion from "./slidesQuestion"
    import rankQuestion from "./rankQuestion"
    import arrangeQuestion from "./arrangeQuestion"
    import ModalEditQuestions from "../../components/ModalEditQuestions";
import { watch } from 'vue';

    export default {
        name: 'app',
        components: {trueOrFalseQuestion, multipleChoicesQuestion, freeTextQuestion, slidesQuestion, rankQuestion, arrangeQuestion, ModalEditQuestions},
        props: {
            template: Object,
            type: String,
            opType: String
        },
        setup(props, context) {

            const template = toRef(props, 'template');
            const opType = toRef(props, 'opType');
            const type = toRef(props, 'type');
            const currentTab = ref('trueOrFalse');
            const isShow = ref(false);
            const questionsKeys = ref(['trueOrFalse', 'multipleChoice', 'freeText', 'slides', 'rank', 'arrange']);
            const message = ref(null);
            const qKey = ref("");
            onMounted(async () => {
                // for(let index = 0; index < questionsKeys.value.length ; index++){
                //     console.log('de ', template.value.questions[questionsKeys.value[index]])
                    // if(template.value.questions[questionsKeys.value[index]].questions.length > 0){
                        context.emit('setTitle', template.value.questions['trueOrFalse'].title);
                    // }
                // }
            });


 
watch(currentTab, (newTab) => {
  const url = new URL(window.location);
  url.searchParams.set('tab', newTab);
  window.history.replaceState({}, '', url);
});
            const openTap = (e, tapName, tapTitle) => {
                currentTab.value = tapName;
                let i, tabcontent, tablinks;
                if (process.env.VUE_APP_ENV === 'development')
                    console.log('temp => ', template.value)
                context.emit('setTitle', tapTitle);
                tabcontent = document.getElementsByClassName("tabcontent");

                if (tapName !== 'trueOrFalse')
                    e.currentTarget.className += " trueOrFalse";
                for (i = 0; i < tabcontent.length; i++) {
                    tabcontent[i].style.display = "none";
                }
                tablinks = document.getElementsByClassName("tablinks");
                for (i = 0; i < tablinks.length; i++) {
                    tablinks[i].className = tablinks[i].className.replace(" active", "");
                }
                document.getElementById(tapName).style.display = "block";
                e.currentTarget.className += " active";
            };

            const showModalEdit = (titleQuestion) => {

                console.log({titleQuestion});
                let title = template.value.questions[titleQuestion].title;
                qKey.value = titleQuestion;
                console.log(qKey.value)
                message.value = 'Do you want to edit the ' + title + ' question?';
                isShow.value = true;
            };
            const showTitle = (tapTitle) => {
                context.emit('setTitle', tapTitle);
                isShow.value = false;
            };

            return {
                template,
                type,
                opType,
                questionsKeys,
                currentTab,
                isShow,
                message,
                qKey,
                openTap,
                showModalEdit,
                showTitle
            }
        }
    }

</script>

<style scoped>
    .questions-container{
        margin-top:20px;
        padding:0 13px 0 30px;
    }
    .card-content-container{
        align-items: center;
        
    }
    .card-content-container p{
        margin: 0;
    }
    #tablink-t-f{
        width:24%;
    }
    #tablink-m-c{
        width:25%;
    }
    #tablink-f-t{
        width:15%;
    }
    #tablink-s{
        width:11%;
    }
    #tablink-r{
        width:11%;
    }
    #tablink-a{
        width:14%;
    }
    .product-details{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'poppins', sans-serif;
    }
    .product-details:hover + .product-details-full {
        position: absolute;
        top: -35px;

        
        background-color: #002634;
        display: flex;
        padding:0;
        font-family: 'Lato', sans-serif;
        border-radius: 5px;
    }

    .product-details-full {
        display: none;
    }
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }

    .errInputs {
        border: 1px solid red;
        border-bottom: none
    }

    #trueOrFalse {
        display: block;
    }


    .tablinks-container{
        width:100%;
        gap:0.2rem;
    }
    .tabcontent {
        display: none;
        height: 58vh;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        width:100% !important;
        padding:0 !important;
        overflow: unset !important;
        ;
    }
    .tablinks,.active {
        max-width: 24%!important;
        position: relative;
        font-weight: 500 !important;
        font-size: 15px;
        background-color: var(--question-button-background);
        border-radius:5px 5px 0 0 !important;
        background-image: unset;
        color: white !important;
        margin:0;
        padding:0;
        height: 36px;
    }
    /* .tablinks :hover,
    .tablinks :focus
     {
        border-radius: 5px;
        background-color: #E95626 !important;
        color: white !important;
        background-image: unset;
    } */

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: #FFF;
        background-color: transparent;
        outline: 0;
    }

    #slides {
        overflow-y: auto;
    }

</style>